import { InjectionToken } from '@angular/core'
import { Observable } from 'rxjs'
import { NotificatioNCapableServices, NotificationPriority, SystemNotification } from '../types'

export interface NotificationPort {
  // Observables
  readonly dismissAllRequired$: Observable<boolean>

  // Properties
  readonly allNotifications: SystemNotification[]

  // Methods
  setNotDismissed(): void
  addInternalNotification(
    description: string,
    priority: NotificationPriority,
    received: Date,
    responsible: NotificatioNCapableServices,
    id?: string,
    dashboardId?: string
  ): void
  acknowledgePersistedNotification(messageId: string, responsible: string): Observable<unknown>
  removeEmmaTopBarNotification(id: string): void
}

export const NOTIFICATION_PORT = new InjectionToken<NotificationPort>('NotificationPort')
